import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                'app-bar': '#ee7203',
                primary: '#ee7203', //00563b
                secondary:  '#ee7203', //'#427034',   //006f49
                anchor: '#ee7203',
                primaryText: colors.purple.accent1,
                secondaryText: colors.black,
                background: colors.blueGrey.lighten4,
                mycolor: colors.purple.base,
                buttonColor: '#ffffff'
            },
            dark: {
                // background: colors.pink.base,
                // mycolor: colors.purple.base
            },
        },
        options: {
            customProperties: true
        },
    },
});
